<template>
	<page style="background: #fff;">
		<div v-html="content" class="agreement"></div>
	</page>
</template>

<script>
	export default {
		props: {
			type: [String, Number]
		},

		data() {
			return {
				content: ''
			}
		},

		mounted() {
			this.request({
				url: '/article/detail',
				data: {
					article_type: 0,
					id: this.type
				},
				success: data => {
					this.setPageTitle(data.title);
					this.content = data.content;
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.agreement {
		padding: .4rem .32rem;
		line-height: .5rem;
		font-size: .28rem;
	}
</style>